/**************************************************************************************************************************************************
*   MODULE NAME     :  DashboardResults
*   AUTHOR          :  GLSD DEV Team
*   DATE            :  23-03-2021
*   DESCRIPTION     :  Component to load Show all Dashboard Results page
*   Copyright 2021 Eli Lilly and Company
*   All rights reserved
*
/**************************************************************************************************************************************************
*   *** CHANGE HISTORY ***
/**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG1689267
*   DESCRIPTION: <GLSD>: New System Development
/**************************************************************************************************************************************************/
import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Tabs,
  Tab,
  Button,
  OverlayTrigger,
  Tooltip,
  InputGroup,
  Popover,
} from "react-bootstrap";
import {
  FaSpinner,
  FaExclamationTriangle,
  FaTimes,
  FaFile,
  FaHashtag,
} from "react-icons/fa";
import { loadAllDashboardResults } from "../../actions/homeActions";
import { loadAllAlerts } from "../../actions/abstractActions";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import DataTable from "../common/dataTable/DataTable";
import { ddmmmyyyyFormat } from "../common/DateFormat";
import { Component } from "react";
import { exportPDF } from "../common/ExportToPDF";

import "./DashboardResults.css";
import queryString from "query-string";

class DashboardResults extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      data: [],
      alertMasterData: {},
      datatype: this.props.match.params.datatype,
      site: this.props.match.params.site,
      title: queryString.parse(this.props.location.search).title,
    };
  }
  async componentDidMount() {
    await this.loadAlertsData();
    this.loadDashboardDetails();
  }
  loadAlertsData = async () => {
    this.setLoader(true);
    try {
      let response = await this.props.loadAllAlerts();
      let alertMasterData = {};
      response.data.result.map((e) => {
        alertMasterData[e.masterDataKey] = e.masterDataValue;
      });
      this.setState((prevState) => ({
        alertMasterData: alertMasterData,
      }));
    } catch (error) {
      this.setLoader(false);
    }
  };
  setLoader = (isLoading) => this.setState({ isLoading });

  loadDashboardDetails = () => {
    this.setLoader(true);
    let { datatype, site } = this.state;
    this.props
      .loadAllDashboardResults(datatype, site)
      .then(async (res) => {
        if (res && res.data && res.data.result) {
          let data = res.data.result;
          data = await this.mapAbstractsAttributes(data);
          this.setState(
            {
              data: data,
            },
            () => this.setLoader(false)
          );
        } else {
          this.setLoader(false);
        }
      })
      .catch((error) => {
        this.setLoader(false);
      });
  };
  mapAbstractsAttributes = async (abstracts) => {
    if (abstracts && Array.isArray(abstracts))
      abstracts = await Promise.all(abstracts.map(async (abstract) => {
        abstract.alert = await this.generateAlert(abstract);
        return abstract;
      }));
    return abstracts;
  };
  compareDate(_date, _days) {
    var date_C = new Date(_date);
    date_C.setDate(date_C.getDate() + _days);
    return date_C <= new Date();
  }
  async generateAlert(abstract) {
    let alertFlag = false;
    let alertTitle = "";
    if (this.state.alertMasterData === null) {
      await this.loadAlertsData();
    }

    const { alertMasterData } = this.state;
  
    if (
      abstract.migrateFlag === false
    ) {
      if (!abstract["dateAbstractReviewed"]) {
        alertFlag = this.compareDate(
          abstract["dateRecordReceived"],
          parseInt(alertMasterData["ALERT_DAYS_ABST_NOT_REVD"])
        );
        alertTitle = "Abstract Not Reviewed";
      } else if (
        abstract["dateTranslationRequested"] &&
        !abstract["dateTranslationReceived"]
      ) {
        alertFlag = this.compareDate(
          abstract["dateTranslationRequested"],
          parseInt(alertMasterData["ALERT_DAYS_ART_NOT_RECVD"])
        );
        alertTitle = "Translation Not Returned";
      } else if (
        abstract["dateArticleOrdered"] &&
        !abstract["dateArticleReceived"]
      ) {
        alertFlag = this.compareDate(
          abstract["dateArticleOrdered"],
          parseInt(alertMasterData["ALERT_DAYS_ART_NOT_REVD"])
        );
        alertTitle = "Article Not Received";
      } else if (
        abstract["dateArticleReceived"] &&
        !abstract["dateArticleReviewed"]
      ) {
        alertFlag = this.compareDate(
          abstract["dateArticleReceived"],
          parseInt(alertMasterData["ALERT_DAYS_TRANS_NOT_RET"])
        );
        alertTitle = "Article Not Reviewed";
      } else if (
        abstract["dateTranslationReceived"] &&
        !abstract["dateArticleReviewed"]
      ) {
        alertFlag = this.compareDate(
          abstract["dateTranslationReceived"],
          parseInt(alertMasterData["ALERT_DAYS_TRANS_NOT_RET"])
        );
        alertTitle = "Article Not Reviewed";
      } else {
        alertFlag = false;
      }
    }
    return alertFlag;
  }
  handleBackFunction = () => {
    window.close();
  };
  openAbstractDetailWindow = (abstractId) => {
    window.open(
      `/abstractDetail/${abstractId}`,
      "",
      `width=${window.innerWidth},height=${window.innerHeight}`
    );
  };
  handlePrintFunction = async () => {
    this.exportFile();
  };
  exportFile() {
    const { data } = this.state;
    let colSelected = [
      "dateRecordReceived",
      "dateArticleReceived",
      "dateTranslationReceived",
      "dateClosed",
    ];
    var headers = [
      [
        "Alert",
        "Title",
        "Author",
        "Product",
        "Status",
        "Date Record Received",
        "Date Article Received",
        "Date Translation Received",
        "Date Closed",
      ],
    ];
    var widths = [20, 205, 125, 65, 65, 50, 50, 50, 50];
    data.sort((a, b) => (a.title > b.title ? 1 : -1));

    const dataDashboard = data.map((elt) => {
      let element;
      let alert = "";
      alert =
        alert +
        (elt.migrateFlag == true
          ? "#"
          : "");
      alert = alert + (elt.active === false ? "X" : "");
      alert =
        alert +
        (elt.alert && elt.active === true && elt.enblAlrtsAndVldtinsFlag == false
          ? "!"
          : "");

      if (elt.product)
        element = [
          alert,
          elt.title,
          elt.authors,
          elt["product"]["masterDataValue"],
          elt["status"]["masterDataValue"],
        ];
      else
        element = [
          alert,
          elt.title,
          elt.authors,
          elt["product"],
          elt["status"]["masterDataValue"],
        ];
      colSelected.forEach((ele) => {
        let dt =
          ele.includes("date") && elt[ele]
            ? ddmmmyyyyFormat(elt[ele])
            : elt[ele]
            ? elt[ele]
            : "";

        element.push(dt);
      });
      return element;
    });
   
    let titlepdf = this.state.title ? this.state.title : " ";
    exportPDF(
      "Dashboard Results",
      titlepdf,
      headers,
      dataDashboard,
      widths,
      ""
    );
  }
  render() {
    const { isLoading, data, title } = this.state;
    let columns = [
      {
        dataField: "abstractId",
        text: "Abstract",
        hidden: true,
      },
      {
        dataField: 'alert',
        text: 'Alert',
        csvExport: false,
        headerClasses: "width-5",
        headerStyle: (colum, colIndex) => {
          return { width: '5vw' };
        },
        formatter: (cellContent, row) => {
          return <span style={{ display: 'inline-block', position: 'relative' }}>
            {row && (row.migrateFlag == true )
              && <FaHashtag style={{ color: 'gray' }} />}
            {row && row.active === false && <FaTimes style={{ color: 'red' }} />}
            {row && row.alert && row.active === true && row.enblAlrtsAndVldtinsFlag == true && <FaExclamationTriangle style={{ color: 'orange' }} />}
          </span>;
        }
      },
      {
        dataField: "title",
        text: "Title",
        searchable: true,
        hidden: true,
      },
      {
        dataField: "title",
        text: "Title",
        searchable: true,
        sort: true,
        style: { textAlign: "left" },
        formatter: (cellContent, row) => {
          const _popOver = (
            <OverlayTrigger
              placement="right"
              popperConfig={{
                modifiers: {
                  preventOverflow: {
                    enabled: false,
                  },
                },
              }}
              overlay={
                <Popover style={{ maxWidth: "50vw" }} id="popover-contained">
                  <Popover.Content>{row.title}</Popover.Content>
                </Popover>
              }
            >
              <span
                className="fake-link"
                onClick={() => this.openAbstractDetailWindow(row.abstractId)}
              >
                {row.title && row.title.length <= 70
                  ? row.title
                  : row.title && row.title.substr(0, 70) + "..."}
              </span>
            </OverlayTrigger>
          );
          return row && row.title ? _popOver : "";
        },
      },
      {
        dataField: "authors",
        text: "Author",
        searchable: true,
        hidden: true,
        headerStyle: (colum, colIndex) => {
          return { textTransform: 'none' };
        },
      },
      {
        dataField: "authors",
        text: "Author(s)",
        searchable: true,
        sort: true,
        style: { textAlign: "left" },
        headerStyle: (colum, colIndex) => {
          return { textTransform: 'none' };
        },
        formatter: (cellContent, row) => {
          const _popOver = (
            <OverlayTrigger
              placement="right"
              popperConfig={{
                modifiers: {
                  preventOverflow: {
                    enabled: false,
                  },
                },
              }}
              overlay={
                <Popover style={{ maxWidth: "40vw" }} id="popover-contained">
                  <Popover.Content>{row.authors}</Popover.Content>
                </Popover>
              }
            >
              <div>
                {row.authors&& row.authors.length <= 70
                  ? row.authors
                  : row.authors && row.authors.substr(0, 70) + "..."}
              </div>
            </OverlayTrigger>
          );
          return row && row.authors ? _popOver : "";
        },
      },
      {
        dataField: "productId",
        headerClasses: "width-100",
        text: "Product",
        searchable: true,
        sort: true,
        formatter: (cellContent, row) => {
          return row && row.product && row.product.masterDataValue
            ? row.product.masterDataValue
            : "";
        },
      },
      {
        dataField: "statusId",
        text: "Status",
        searchable: true,
        headerClasses: "width-120",
        sort: true,
        formatter: (cellContent, row) => {
          return row && row.status && row.status.masterDataValue
            ? row.status.masterDataValue
            : "";
        },
      },
      {
        dataField: "dateRecordReceived",
        text: "Date Record Received",
        headerClasses: "width-120",
        searchable: true,
        sort: true,
        formatter: (cellContent, row) => {
          return row &&
            row.dateRecordReceived &&
            !isNaN(new Date(row.dateRecordReceived).getTime())
            ? ddmmmyyyyFormat(row.dateRecordReceived)
            : "";
        },
      },
      {
        dataField: "dateArticleReceived",
        text: "Date Article Received",
        headerClasses: "width-120",
        searchable: true,
        sort: true,
        formatter: (cellContent, row) => {
          return row &&
            row.dateArticleReceived &&
            !isNaN(new Date(row.dateArticleReceived).getTime())
            ? ddmmmyyyyFormat(row.dateArticleReceived)
            : "";
        },
      },

      {
        dataField: "dateTranslationReceived",
        headerClasses: "width-120",
        text: "Date Translation Received",
        searchable: true,
        sort: true,
        formatter: (cellContent, row) => {
          return row &&
            row.dateTranslationReceived &&
            !isNaN(new Date(row.dateTranslationReceived).getTime())
            ? ddmmmyyyyFormat(row.dateTranslationReceived)
            : "";
        },
      },

      {
        dataField: "dateClosed",
        headerClasses: "width-120",
        text: "Date Closed",
        searchable: true,
        sort: true,
        formatter: (cellContent, row) => {
          return row &&
            row.dateClosed &&
            !isNaN(new Date(row.dateClosed).getTime())
            ? ddmmmyyyyFormat(row.dateClosed)
            : "";
        },
      },
    ];
    return (
      <>
        {isLoading && (
          <div className="loader">
            <FaSpinner />
          </div>
        )}
        <table className="print-table">
          <thead>
            <tr>
              <td>
                <div className="page-header-space"></div>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div className="CommonWrap dashboardResults">
                  <Container fluid>
                    <div className="headerpart headerpartCustom">
                      <Row>
                        <Col sm={9}>
                          {" "}
                          <h1>{title}</h1>
                        </Col>
                        <Col sm={{ span: 1, offset: 9 }} className="mt-3"></Col>
                        <Col sm={2} className="mt-3">
                          <Button
                            variant="primary"
                            type="submit"
                            className="mr-2 btn btn-primary"
                            onClick={this.handleBackFunction}
                          >
                            Close
                          </Button>
                          <Button
                            variant="primary"
                            type="submit"
                            className="mr-2 btn btn-primary"
                            onClick={this.handlePrintFunction}
                          >
                            Print All
                          </Button>
                        </Col>
                      </Row>
                    </div>
                    <div className="mt-5 fullHeightTable">
                      <DataTable
                        keyField="abstractId"
                        defaultSortField="title"
                        data={data}
                        columns={columns}
                        csvName={false}
                        sizePerPage={[100, 200, 300, 400, 500]}
                        showSearch={true}
                        showPagination={true}
                      />
                    </div>
                  </Container>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td>
                <div className="page-footer-space"></div>
              </td>
            </tr>
          </tfoot>
        </table>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      loadAllDashboardResults,
      loadAllAlerts,
    },
    dispatch
  );
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DashboardResults)
);
